import store from '@/store'
import {
  PATH_NAME_CUSTOMER,
  PATH_NAME_CUSTOMER_USER_QNA,
  PATH_NAME_FAQ,
  PATH_NAME_NOTICE_LIST,
  PATH_NAME_NOTICE_VIEW
} from '@/common/router.const'

export default [
  {
    path: '/customer',
    name: PATH_NAME_CUSTOMER,
    components: {
      customer: () => import(/* webpackChunkName: "View" */ '@/views/customer/CustomerView')
    },
    beforeEnter: (to, from, next) => {
      store.commit('setBeforePathOpenMyPooq', from.fullPath)
      if (to.path.indexOf('.html') > -1) {
        next(to.path.replace('.html', ''))
      }
      next()
    },
    children: [
      {
        path: 'faq',
        name: PATH_NAME_FAQ,
        alias: 'faq.html',
        components: {
          faq: () => import(/* webpackChunkName: "faq" */ '@/components/lnb/customer/CustomerFaq')
        }
      },
      {
        path: 'notice_list',
        name: PATH_NAME_NOTICE_LIST,
        alias: 'notice_list.html',
        components: {
          notice_list: () => import(/* webpackChunkName: "notice_list" */ '@/components/lnb/customer/CustomerNotice')
        }
      },
      {
        path: 'notice_view/:noticeid?',
        name: PATH_NAME_NOTICE_VIEW,
        components: {
          notice_view: () => import(/* webpackChunkName: "notice_view" */ '@/components/lnb/customer/CustomerNoticeView')
        },
        props: true
      },
      {
        path: 'user_qna',
        name: PATH_NAME_CUSTOMER_USER_QNA,
        alias: 'user_qna.html',
        components: {
          customer_user_qna: () => import('@/components/lnb/customer/CustomerUserQna')
        }
      }
    ]
  }
]
